import {
  LOSS_LIMIT,
  MAXIMUM_CREDIT_LIMIT,
  REALITY_CHECK,
  SESSION_DELAYED_LIMIT,
  SESSION_LIMIT,
  WAGER_LIMIT,
} from '@ezugi/constants';

/**
 * The following two arrays are used only for DIRECT integration (non-oss)
 * The decision to keep ukgc notifications separately was due to lack of time
 * for regression testing
 */
export const notificationTypes = [
  SESSION_DELAYED_LIMIT, // NETHERLANDS
  MAXIMUM_CREDIT_LIMIT, // NETHERLANDS
]; // Used in Regulations dialog (NON-OSS)

// Used in UKGCMessage dialog (non-OSS)
export const ukgcNotifications = [ REALITY_CHECK, SESSION_LIMIT, WAGER_LIMIT, LOSS_LIMIT ];
